import React from 'react'
import cx from 'classnames'
import { Message } from 'sb-react-intl'

import messages from './messages'
import s from './ButtonContent.scss'


export type ButtonContentProps = {
  children?: React.ReactNode
  title?: string | ReactIntlMessage
  size?: string
  loading?: boolean
  loadingMessage?: string | ReactIntlMessage
  centering?: boolean
  noPadding?: boolean
}

const ButtonContent: React.FunctionComponent<ButtonContentProps> = (props) => {
  const { children, title, size, loading, loadingMessage, centering, noPadding } = props

  const className = cx(s[size], {
    [s.center]: centering,
    [s.noPadding]: noPadding,
  })

  if (loading) {
    return <Message className={className} text={loadingMessage || messages.loading} />
  }

  if (title) {
    return <Message className={className} text={title} />
  }

  return <div className={className}>{children}</div>
}

ButtonContent.defaultProps = {
  size: 'md',
}


export default ButtonContent
